import { faMinusSquare, faSquare } from '@fortawesome/free-regular-svg-icons';
import {
  faCircle,
  faCube,
  faDrawPolygon,
  faLongArrowAltUp,
  faMagic,
  faMousePointer,
  faPaintBrush,
  faProjectDiagram,
  faRulerCombined,
  faSearch,
  faSlash,
  faThLarge,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { ToolName, VectorTaggingToolObjectless } from './tools-names';

export type ToolConfig<T> = {
  name: T;
  icon?: IconDefinition;
  iconTransform?: string;
  tooltip?: string;
};

// eslint-disable-next-line @typescript-eslint/ban-types -- All tools are defined
export type ToolsConfig = Record<ToolName, ToolConfig<ToolName>>;

// All tooling config
// Icon transform reference:
// - https://docs.fontawesome.com/web/style/power-transform
export const toolsConfig: ToolsConfig = {
  Arrow: {
    name: 'Arrow',
    icon: faLongArrowAltUp,
    iconTransform: 'rotate-50 grow-6',
  },
  Cuboid: {
    name: 'Cuboid',
    icon: faCube,
  },
  Keypoint: {
    name: 'Keypoint',
    icon: faProjectDiagram,
  },
  Line: {
    name: 'Line',
    icon: faSlash,
    iconTransform: 'flip-h',
  },
  Point: {
    name: 'Point',
    icon: faCircle,
    iconTransform: 'shrink-8',
  },
  Polygon: {
    name: 'Polygon',
    icon: faDrawPolygon,
  },
  Rectangle: {
    name: 'Rectangle',
    icon: faSquare,
  },
  SliderRectangle: {
    name: 'SliderRectangle',
    icon: faMinusSquare,
    iconTransform: 'rotate-90',
  },
  Measure: {
    name: 'Measure',
    icon: faRulerCombined,
  },
  Zoom: {
    name: 'Zoom',
    icon: faSearch,
  },
  ColorSelect: {
    name: 'ColorSelect',
    icon: faMousePointer,
  },
  Fill: {
    name: 'Fill',
    icon: faMagic,
  },
  Paintbrush: {
    name: 'Paintbrush',
    icon: faPaintBrush,
  },
  Superpixel: {
    name: 'Superpixel',
    icon: faThLarge,
  },
  Edit: {
    name: 'Edit',
    icon: faMousePointer,
  },
  Select: {
    name: 'Select',
    icon: faMousePointer,
  },
};

export const vectorTaggingToolsConfig = {
  Arrow: toolsConfig.Arrow,
  Cuboid: toolsConfig.Cuboid,
  Keypoint: toolsConfig.Keypoint,
  Line: toolsConfig.Line,
  Point: toolsConfig.Point,
  Polygon: toolsConfig.Polygon,
  Rectangle: toolsConfig.Rectangle,
  SliderRectangle: toolsConfig.SliderRectangle,
  Measure: toolsConfig.Measure,
  Zoom: toolsConfig.Zoom,
  // eslint-disable-next-line @typescript-eslint/ban-types -- All tools for vector tagging are defined
} as Record<
  VectorTaggingToolObjectless,
  ToolConfig<VectorTaggingToolObjectless>
>;
